package com.bikompanion.ui.strings

val PtBikompanionStrings = object : BikompanionStrings {
    override val actionRetry = "Tentar novamente"
    override val actionClose = "Fechar"
    override val actionSubmit = "Enviar"
    override val detailsLabel = "Detalhes"
    override val detailsShow = "Mostrar detalhes"
    override val detailsHide = "Ocultar detalhes"
    override val actionGetDirections = "Como chegar"
    override val actionShareStation = "Compartilhar estação"
    override val linkCopied = "Link copiado"
    override val locateShow = "Mostrar minha localização"
    override val locateFollowHeading = "Seguir minha direção"
    override val locateStopFollowing = "Parar de me seguir"
    override val settingsTitle = "Configurações"
    override val actionBack = "Voltar"
    override val settingsAppearance = "Aparência"
    override val settingsLanguage = "Idioma"
    override val languageSystem = "Padrão do sistema"
    override val themeSystem = "Sistema"
    override val themeLight = "Claro"
    override val themeDark = "Escuro"
    override val settingsNotifications = "Notificações"
    override val stationAlerts = "Alertas de estações"
    override val notificationsOn = "Ativados: avisamos quando uma estação vigiada tiver uma bicicleta"
    override val notificationsOff = "Desativados: as estações vigiadas não podem avisar você"
    override val notificationsBlocked = "Bloqueados: permita as notificações nas configurações do site no navegador"
    override val actionManage = "Gerenciar"
    override val actionTurnOn = "Ativar"
    override val settingsSupport = "Suporte"
    override val sendFeedback = "Enviar feedback"
    override val sendFeedbackDescription = "Conte sobre um problema ou dado errado de uma estação"
    override val shareApp = "Compartilhar o app"
    override val settingsAbout = "Sobre"
    override val aboutApp = "Sobre o Bikompanion"
    override val aboutDevelopedBy = "Desenvolvido por Tiago Araujo"
    override val aboutDataSources = "Fontes de dados"
    override val sourceCityBikesDescription = "Redes de bicicletas compartilhadas no mundo todo"
    override val sourceGbfsTitle = "Feeds GBFS das operadoras"
    override val sourceGbfsDescription = "Dados das estações em tempo real das operadoras"
    override val sourceOsmTitle = "Colaboradores do OpenStreetMap"
    override val sourceOsmDescription = "Bicicletários e dados do mapa"
    override val sourceCartoDescription = "Blocos do mapa"
    override val aboutLegal = "Legal"
    override val licensesTitle = "Licenças de código aberto"
    override val privacyPolicy = "Política de privacidade"
    override val deleteRatings = "Apagar minhas avaliações"
    override val deleteRatingsDescription = "Envia seu ID anônimo por e-mail para que possamos apagá-las"
    override val licensesLoadFailed = "Não foi possível carregar a lista de licenças"
    override val aboutVersion = { version: String -> "Versão $version" }
    override val issueFlatTire = "Pneu furado"
    override val issueFrontBrake = "Freio dianteiro não funciona"
    override val issueRearBrake = "Freio traseiro não funciona"
    override val issueChain = "Corrente escapando"
    override val issueGears = "Marchas não trocam"
    override val issueSeat = "Selim danificado ou ausente"
    override val issueLights = "Luzes não funcionam"
    override val issueLockOrBasket = "Trava ou cesta danificada"
    override val issueFrame = "Quadro danificado"
    override val issueMotor = "Motor elétrico não funciona"
    override val issueBattery = "Bateria não carrega"
    override val issueOther = "Outro"
    override val networksLoadFailed = "Não foi possível carregar as redes de bikes. Verifique sua conexão."
    override val parkingLoadFailed = "Não foi possível carregar os bicicletários"
    override val parkingLoading = "Procurando bicicletários…"
    override val stationsLoading = "Carregando estações de bicicletas…"
    override val noNetworkHereTitle = "Não há bikes compartilhadas aqui"
    override val noNetworkHereHint = "Afaste o mapa para achar a rede mais próxima"
    override val installTitle = "Instalar o Bikompanion"
    override val installHintIos = "Toque em Compartilhar e depois em Adicionar à Tela de Início."
    override val installHintAndroid = "Baixe o app no Google Play."
    override val actionInstall = "Instalar"
    override val parkingTypeStands = "Paraciclos"
    override val parkingTypeShed = "Abrigo para bikes"
    override val parkingTypeLockers = "Armários para bikes"
    override val parkingTypeBuilding = "Edifício para bikes"
    override val parkingTypeOther = "Bicicletário"
    override val fieldAddress = "Endereço"
    override val fieldCovered = "Coberto"
    override val fieldYes = "Sim"
    override val fieldNo = "Não"
    override val fieldId = "ID"
    override val fieldStationId = "ID da estação"
    override val fieldCoordinates = "Coordenadas"
    override val fieldCapacity = "Capacidade"
    override val fieldNetwork = "Rede"
    override val fieldName = "Nome"
    override val fieldCity = "Cidade"
    override val fieldCountry = "País"
    override val fieldCompany = "Empresa"
    override val fieldLicense = "Licença"
    override val fieldLicenseUrl = "URL da licença"
    override val availabilityBikes = "Bikes"
    override val availabilityElectric = "Elétricas"
    override val availabilityEmpty = "Vazias"
    override val bicingNextPickup = { p0: String -> "Próxima retirada do Bicing em $p0" }
    override val rateTitle = "Consulte ou avalie uma bike"
    override val rateFindingNetworks = "Procurando redes de bikes perto de você…"
    override val rateWhatsWrong = "O que ela tem?"
    override val rateBikeNumber = "Número da bike"
    override val rateElectricBike = "Bike elétrica"
    override val rateVoteBad = "Ruim"
    override val rateVoteGood = "Boa"
    override val rateWhichNetwork = "De qual rede é esta bike?"
    override val refreshRateLimited = "Limite de solicitações atingido — tentando novamente automaticamente"
    override val refreshFailed = "Não foi possível atualizar"
    override val refreshNextUpdate = { p0: Int -> "Próxima atualização em $p0 s" }
    override val refreshUpdating = "Atualizando…"
    override val dataNone = "Ainda sem dados"
    override val dataAgeJustNow = "Dados de agora há pouco"
    override val dataAgeMinutes = { p0: Int -> "Dados de $p0 min atrás" }
    override val dataAgeHours = { p0: Int -> "Dados de $p0 h atrás" }
    override val dataAgeDays = { p0: Int -> "Dados de $p0 d atrás" }
    override val actionOpenOperator = { p0: String -> "Abrir $p0" }
    override val watchNormal = "Monitorar bikes comuns"
    override val watchElectric = "Monitorar bikes elétricas"
    override val watchInstallNormal = "Instale o app para monitorar bikes comuns"
    override val watchInstallElectric = "Instale o app para monitorar bikes elétricas"
    override val watchStopNormal = "Parar de monitorar bikes comuns"
    override val watchStopElectric = "Parar de monitorar bikes elétricas"
    override val actionCheckRateBike = "Consultar / Avaliar bike"
    override val layerStations = "Estações"
    override val layerParking = "Bicicletários"
    override val mapLabelBikes = { p0: Int -> "$p0 bikes" }
    override val mapLabelEbikes = { p0: Int -> "$p0 elétricas" }
    override val mapLabelFree = { p0: Int -> "$p0 vazias" }
    override val scoreHeadline = { p0: String, p1: String -> "Bike $p0 · $p1" }
    override val scoreNoRatings = "Ainda sem avaliações — você pode dar a primeira."
    override val scoreLooksGood = "Parece boa."
    override val scoreHasProblems = "Outras pessoas tiveram problemas com esta bike."
    override val scoreMixed = "Opiniões divididas."
    override val ratingNetworkRequired = "Primeiro escolha a rede desta bike."
    override val ratingThanks = { p0: String -> "Obrigado por avaliar a bike $p0!" }
    override val ratingCooldown = { p0: Int -> "Você já avaliou esta bike recentemente. Tente novamente em $p0 min." }
    override val ratingQueued = "Salvo — enviaremos quando você estiver online de novo."
    override val ratingInvalidBike = "Esse número de bike não é válido para esta rede."
    override val ratingRejected = "Não foi possível salvar a avaliação. Tente novamente mais tarde."
    override val notificationFoundTitle = "Bike disponível"
    override val notificationFoundNormal = { p0: String -> "Bike comum disponível em $p0" }
    override val notificationFoundElectric = { p0: String -> "Bike elétrica disponível em $p0" }
    override val notificationExpiredTitle = "Monitoramento de estação encerrado"
    override val notificationExpiredNormal = { p0: String -> "Monitoramento de bikes comuns em $p0 encerrado após 30 minutos" }
    override val notificationExpiredElectric = { p0: String -> "Monitoramento de bikes elétricas em $p0 encerrado após 30 minutos" }
    override val channelWatchAlertsName = "Alertas de monitoramento de estações"
    override val channelWatchAlertsDescription = "Disponibilidade de bikes e novidades das estações monitoradas"
    override val channelBackgroundWatchName = "Monitoramento de estações em segundo plano"
    override val notificationWatchingTitle = "Monitorando estações de bikes"
    override val notificationWatchingText = "Monitorando as estações escolhidas em segundo plano"
    override val scoreFewRatings = { count: Int ->
        singularOrPlural(
            count,
            "Só $count avaliação até agora.",
            "Só $count avaliações até agora.",
        )
    }
    override val scorePositiveRides = { percent: Int, count: Int ->
        singularOrPlural(
            count,
            "$percent% positivo em $count viagem recente",
            "$percent% positivo nas últimas $count viagens",
        )
    }
}
